/** Escenas divertidas del puerto; sale una al azar cada vez que se entra. */
export const ESCENAS = [
  'aparta',
  'hucha',
  'loro',
  'rebajas',
  'comisiones',
  'faro',
  'nomina',
  'emergencia',
  'botella',
  'gaviota',
] as const;

export type Escena = (typeof ESCENAS)[number];

export function elegirEscena(azar: number = Math.random()): Escena {
  const i = Math.min(ESCENAS.length - 1, Math.floor(azar * ESCENAS.length));
  return ESCENAS[i];
}
